var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNeck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "29px",
    height: "13px",
    viewBox: "0 0 29 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Neck") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Humanuculus",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    fillOpacity: 0.195858829
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard-Copy-31",
    transform: "translate(-201.000000, -79.000000)",
    fill: "#1E428A"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Front-Body---Selections",
    transform: "translate(175.074098, 42.681852)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.1248113,37.2957232 C37.840298,40.2093461 42.8513027,40.1186985 48.1578253,37.0237805 C48.9014055,41.9385496 51.1716668,45.7033388 54.9686093,48.3181483 C51.6691093,48.3648204 42.0997339,48.3648204 26.2604832,48.3181483 C30.7334791,44.611332 33.0215885,40.9371903 33.1248113,37.2957232 Z",
    id: "Neck"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeck);
export default __webpack_public_path__ + "static/media/Neck.b30d3bc49d01a1824f1cee701dbe5f1c.svg";
export { ForwardRef as ReactComponent };